import { mapRecordFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetOneResponse } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import {
  IVendorQuoteImportAttemptLog,
  IVendorQuoteImportAttemptLogRequestPayload,
  IVendorQuoteImportRangeReport,
  IVendorQuoteImportRangeReportRequestPayload,
} from 'dashboard/types';

export const getVendorQuoteImportRangeReport = async (
  requestPayload: IVendorQuoteImportRangeReportRequestPayload,
  signal?: AbortSignal
): Promise<GetOneResponse<IVendorQuoteImportRangeReport>> => {
  const { data } = await partfinitiClient.get(
    `/quote/vq-import-log/range-report?${getQueryStringToSnakeCase(requestPayload, {
      removeNullValues: true,
    })}`,
    signal
  );

  return mapRecordFromServer<IVendorQuoteImportRangeReport>(data.data);
};

export const getVendorQuoteImportAttemptLog = async (
  requestPayload: IVendorQuoteImportAttemptLogRequestPayload,
  signal?: AbortSignal
): Promise<GetOneResponse<IVendorQuoteImportAttemptLog>> => {
  const { data } = await partfinitiClient.get(
    `/quote/vq-import-log/attempt-log?${getQueryStringToSnakeCase(requestPayload, {
      removeNullValues: true,
    })}`,
    signal
  );

  return mapRecordFromServer<IVendorQuoteImportAttemptLog>(data.data);
};
